import React, { useState } from "react";
import PopUpModal from "../../Components/Modal";
import { Button, Form } from "react-bootstrap";
import * as postapi from "../../api/postapi";
import useApi from "../../Hooks/useApi";
import { toast } from "react-toastify";
import PhoneInput from "../../Components/PhoneInput/PhoneInput";
import { RiCheckLine, RiCloseLine } from "react-icons/ri";
import styles from "../../Components/Orders/OrdersWorkspace/OrdersWorkspace.module.css";

const LegacyStatusChangeConfirmationModal = ({ show, onHide, toggle, id, status, trx_status, paymentGatewayResponse }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [deliveryPersonName, setDeliveryPersonName] = useState("");
  const [deliveryPersonPhone, setDeliveryPersonPhone] = useState("");
  const [dontSendSms, setDontSendSms] = useState(false);
  const changeOrderStatus = useApi(postapi.LegacychangeOrderStatus, { hasCatchError: true });
  const statusMap = {
    Confirmed: "Confirm",
    Picked: "Pick",
    Shipped: "Ship",
    Delivered: "Deliver",
    Returned: "Return",
    Cancelled: "Cancel",
  };

  const statusDescription = {
    Confirmed: "confirm this order? The seller will be notified to prepare the order for pickup.",
    Picked: "mark this order as picked? A delivery person must be assigned for pickup.",
    Shipped: "mark this order as shipped?",
    Delivered: "mark this order as delivered? The customer and seller will be notified.",
    Returned: "mark this order as returned? A reason is required.",
    Cancelled: "cancel this order? A reason is required.",
  };

  const close = () => {
    setIsClicked(false);
    onHide();
    setError("");
    setDontSendSms(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var response;
      setValidated(true);
      if (status === "Picked") {
        if (deliveryPersonName !== "" && deliveryPersonPhone !== "") {
          setIsClicked(true);
          response = await changeOrderStatus.request({ id, status, postman_name: deliveryPersonName, postman_phone: deliveryPersonPhone, send_sms: !dontSendSms });
        }
      } else {
        setIsClicked(true);
        response = await changeOrderStatus.request({ id, status, trx_status, send_sms: !dontSendSms });
      }
      if (response.status === 200) {
        toast.success(`${response?.data?.data?.message}`, {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setValidated(false);
        setDeliveryPersonName("");
        setDeliveryPersonPhone("");
        setDontSendSms(false);
        close();
        toggle();
      }
    } catch (error) {
      setError(error.response.data.error.message);
      setValidated(false);
      toggle();
    }
  };

  return (
    <PopUpModal title={`${statusMap[status]} Order`} show={show} onHide={close} closeButton={false}>
      <>
        {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}

        <div>
          <span className="d-flex justify-content-center pb-4 text-center">Are you sure you want to {statusDescription[status] || `change the status to ${status}?`}</span>
        </div>
        {paymentGatewayResponse && (
          <div className="mb-3 p-3 border rounded" style={{ backgroundColor: "#f8f9fa" }}>
            <h6 className="mb-2">Payment Gateway Response:</h6>
            <div className="small">
              {Object.entries(paymentGatewayResponse).map(([key, value]) => (
                <div key={key} className="d-flex justify-content-between py-1 border-bottom">
                  <strong>{key}:</strong>
                  <span className="text-end ms-2">{typeof value === "object" ? JSON.stringify(value) : String(value)}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        {status === "Picked" ? (
          <Form noValidate validated={validated}>
            <Form.Group>
              <label>
                Delivery Person Name<span className="text-danger">*</span>
              </label>
              <Form.Control
                type="text"
                placeholder="Delivery Person Name"
                required
                name="deliveryPersonName"
                maxLength={35}
                value={deliveryPersonName}
                onChange={(e) => {
                  setDeliveryPersonName(e.target.value);
                }}
              />
              <Form.Control.Feedback type="invalid">Enter Delivery Person Name.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="my-3">
              <label>
                Delivery Person Phone<span className="text-danger">*</span>
              </label>
              <PhoneInput placeholder="+92-3XX-XXXXXXX" value={deliveryPersonPhone} onChange={(e) => setDeliveryPersonPhone(e.target.value)} required />
              <Form.Control.Feedback type="invalid">* Please Enter Delivery Person Phone Number</Form.Control.Feedback>
            </Form.Group>
          </Form>
        ) : (
          <></>
        )}
        <Form.Group className="mb-3">
          <Form.Check type="switch" id="dont-send-sms-toggle" label="Don't Send SMS" checked={dontSendSms} onChange={(e) => setDontSendSms(e.target.checked)} />
        </Form.Group>
        <div className={styles.modalActions}>
          <Button className={styles.modalAction} variant="outline-secondary" onClick={close}>
            <RiCloseLine aria-hidden="true" /> Cancel
          </Button>
          <Button className={styles.modalAction} variant="primary" onClick={handleSubmit} disabled={isClicked}>
            <RiCheckLine aria-hidden="true" /> {statusMap[status]}
          </Button>
        </div>
      </>
    </PopUpModal>
  );
};

export default LegacyStatusChangeConfirmationModal;
